import TextFill from 'textfilljs';

const resizeFont = (ele, minFontPixels, maxFontPixels, eleWidth = null, eleHeight = null) => {
  TextFill(ele, {
    minFontPixels,
    maxFontPixels,
    autoResize: true,
    explicitWidth: eleWidth,
    explicitHeight: eleHeight,
  });
};

export default resizeFont;
